
import { CUSTOM_FIELD_SUBJECT_TYPES } from "./customFieldTypes";
import { ParameterParams } from "./parameterTypes";
import { FusaReply } from "./replyTypes";
import { PendingValidation } from "./validationTypes";

// when these types are modified check if updates are required for the following:
// - cascade delete
// - duplicators
export enum  DataTypes {
  Operation = 'operation',
  Parameter = 'parameter',
  Container = 'container',
}

export interface ItemReferenceCreateParams {
  dataSourceId: string;
  dataSourceType: DataTypes;
  dataConsumerId: string;
  dataConsumerType: DataTypes;
  disabled?: boolean;
  sourceObjectKeyId?: string;
  consumerObjectKeyId?: string;
  isInterpolated?: boolean;
}

export interface ItemReferenceParams extends ItemReferenceCreateParams {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  disabled: boolean;
  isInterpolated: boolean;
  /** The org that owns the reference, its consumer's. ItemReferenceAccess writes it from the writer org; callers never choose it. */
  propelOrgId?: string;
}

export interface CreateReferenceRequest extends ItemReferenceCreateParams {
}

export interface CreateReferenceResponse extends ReferenceResponse {
  updatedParameters: ParameterParams[];
  /** See `UpdatedParamsAndRefs.pendingValidations`. */
  pendingValidations?: PendingValidation[];
}

export interface ReferenceResponse extends FusaReply {
  reference?: ItemReferenceParams;
}

export interface ReferencesResponse extends FusaReply {
  references: ItemReferenceParams[];
}

export const fieldMap = {
  [CUSTOM_FIELD_SUBJECT_TYPES.PARAMETER]: DataTypes.Parameter,
  [CUSTOM_FIELD_SUBJECT_TYPES.REPORT_ITEM]: null,
  [CUSTOM_FIELD_SUBJECT_TYPES.EQUIPMENT]: null,
};
